import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'tmTimeFromNumber',
    standalone: false
})
export class TimeFromNumberPipe implements PipeTransform {
    transform(value: number) {
        const hour = Math.trunc(value);
        const minute = value - hour;
        return `${hour > 12 ? hour - 12 : hour}:${Math.trunc(minute * 60)
            .toString()
            .padStart(2, '0')} ${hour >= 12 ? 'pm' : 'am'}`;
    }
}
